<ws-modal-wrapper headerLabel="Picklist Items"
                  [hideSave]="true"
                  cancelLabel="Close"
                  (cancel)="cancel()">
    @if (params.picklist) {
        <div class="modal-body exclude-modal-styling">
            @if (params.picklist.length) {
                <ul class="list-group" style="max-height: 500px; overflow-y: auto;">
                    @for (item of params.picklist; track item) {
                        <li class="list-group-item">{{ item.name }}</li>
                    }
                </ul>
            }
            @if (!params.picklist.length) {
                <span class="lead text-muted"><em>Empty</em></span>
            }
        </div>
    }
</ws-modal-wrapper>
